exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Settings-module__wrapper___3eN-T{display:grid;gap:1.5rem}.Settings-module__wrapper___3eN-T form{display:grid;gap:1rem}.Settings-module__wrapper___3eN-T form .Settings-module__button-wrapper___2779b{margin:20px 0 0 auto}", ""]);

// exports
exports.locals = {
	"wrapper": "Settings-module__wrapper___3eN-T",
	"button-wrapper": "Settings-module__button-wrapper___2779b"
};